var _LeftMenu, _Logo, _RightSectionWrapper, _SubmenuBackdrop;
import { Fragment } from "react";
import clsx from "clsx";
import LeftMenu from "./components/LeftMenu";
import Logo from "./components/Logo";
import RightSectionWrapper from "./components/RightSectionWrapper";
import Navbar from "./ui/Navbar";
import NavbarContainer from "./ui/NavbarContainer";
import SubmenuBackdrop from "./ui/SubmenuBackdrop";
import { useMainMenuContext } from "./hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MainMenu = function MainMenu() {
  var _useMainMenuContext = useMainMenuContext(),
    layoutConfig = _useMainMenuContext.layoutConfig;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Navbar, {
      children: /*#__PURE__*/_jsxs(NavbarContainer, {
        className: clsx('flex justify-between', layoutConfig.navType === 'dashboard' && 'max-w-full'),
        navType: layoutConfig.navType,
        children: [/*#__PURE__*/_jsxs("div", {
          className: clsx('flex items-center lg:flex-row-reverse', layoutConfig.newSidebarEnabled && 'w-1/2'),
          children: [_LeftMenu || (_LeftMenu = /*#__PURE__*/_jsx(LeftMenu, {})), _Logo || (_Logo = /*#__PURE__*/_jsx(Logo, {}))]
        }), _RightSectionWrapper || (_RightSectionWrapper = /*#__PURE__*/_jsx(RightSectionWrapper, {}))]
      })
    }), _SubmenuBackdrop || (_SubmenuBackdrop = /*#__PURE__*/_jsx(SubmenuBackdrop, {}))]
  });
};
export default MainMenu;